module.exports = "/_next/static/images/445576b40fe64b01713c55ab197f7257-Nubank_HickDuarte_59058 1_lg.png";